import { render } from "./SideModal.vue?vue&type=template&id=023dc0c6&scoped=true"
import script from "./SideModal.vue?vue&type=script&lang=js"
export * from "./SideModal.vue?vue&type=script&lang=js"

import "./SideModal.vue?vue&type=style&index=0&id=023dc0c6&lang=scss&scoped=true"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-023dc0c6"]])

export default __exports__